import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
  ViewEncapsulation
} from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './app-navigation.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "flex flex-col lg:flex-row"
  }
})
export class AppNavigationComponent {
  public readonly menuItemClicked = output();

  public onMenuItemClick() {
    this.menuItemClicked.emit();
  }

  public readonly tabs: Array<{
    name: string,
    href: string,
  }> = [
    {
      name: $localize`:@@nav.home:Home`,
      href: './'
    },
    {
      name: $localize`:@@nav.about:About Us`,
      href: './about'
    },
    {
      name: $localize`:@@nav.faq:FAQ`,
      href: './faq'
    },
    {
      name: $localize`:@@nav.campaigns:Campaigns`,
      href: './campaigns'
    },
    {
      name: $localize`:@@nav.donate_car:Donate Car`,
      href: './donate-car'
    },
    {
      name: $localize`:@@nav.contact:Contact Us`,
      href: './contact'
    }
  ]
}
